import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { FaCalendarAlt, FaRegClock } from "react-icons/fa";
import { HiArrowLongRight } from "react-icons/hi2";

export default function OneService({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    if (appContext && appContext.navTo) {
      appContext.navTo({
        item: 'view',
        subItem: 'news',
        extraItem: data.uuid,
      });
    } else {
      console.log("Navigating to news item:", data.uuid);
    }
  }

  // Kuchukua tarehe iliyotengenezwa vizuri (Kama ipo kwenye data)
  const newsDate = data.created_at ? new Date(data.created_at).toLocaleDateString('sw-TZ', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }) : "Habari";

  return (
    <div 
      className="premium-news-card card border-0 shadow-sm position-relative overflow-hidden mb-4"
      onClick={view}
    >
      {/* 1. BACKGROUND IMAGE WITH HOVER LAYER */}
      <div 
        className="news-card-bg"
        style={{ backgroundImage: `url(${data.coverPhoto})` }}
      />
      
      {/* 2. PREMIUM GRADIENT OVERLAY */}
      <div className="news-card-overlay position-absolute top-0 start-0 w-100 h-100" />

      {/* 3. FLOATING TOP BADGE */}
      <div className="news-floating-badge position-absolute top-0 start-0 m-3 px-3 py-1.5 rounded-pill d-flex align-items-center gap-2">
        <FaCalendarAlt className="badge-icon-accent" />
        <span className="fw-bold text-uppercase tracking-wider">{newsDate}</span>
      </div>

      {/* 4. CONTENT BOTTOM WRAPPER */}
      <div className="news-card-content position-absolute bottom-0 start-0 w-100 p-4 d-flex flex-column gap-2">
        
        {/* Title Area */}
        <h4 className="news-card-title fw-bold text-white text-uppercase m-0 line-clamp-2">
          {data.title}
        </h4>

        {/* Action / Read More Trigger Line */}
        <div className="news-action-link d-flex align-items-center gap-2 text-warning fw-bold mt-2">
          <span className="small-action-text">Soma Zaidi</span>
          <HiArrowLongRight className="news-arrow-animate fs-5" />
        </div>

      </div>
    </div>
  );
}